import { useVerifyResetToken } from "@/api/services/main/auth";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { LoginLogo } from "@/features/auth/components/LoginLogo";
import { ResetPasswordForm } from "@/features/auth/components/ResetPasswordForm";
import { TResetPasswordQuery } from "@/features/auth/types/resetPasswordQuery";
import { AppRoutes } from "@/routes/config";
import { getQueryFromURL } from "@/utils/url";
import { Stack } from "@mui/material";
import { FC } from "react";
import { Navigate } from "react-router-dom";

type TResetPasswordPageProps = {};

export const ResetPasswordPage: FC<TResetPasswordPageProps> = () => {
  const query = getQueryFromURL<TResetPasswordQuery>();
  const hasRequiredQuery = Boolean(query?.email && query?.resetToken && query?.externalId);
  const { isLoading, isError, isSuccess } = useVerifyResetToken({
    email: query?.email,
    resetToken: query?.resetToken,
    externalId: query?.externalId,
  });

  if (!hasRequiredQuery || isError) return <Navigate to={AppRoutes.pageNotFound} replace />;
  if (isLoading || !isSuccess) return <LoadingPage />;

  return (
    <Stack gap={6} alignItems="center">
      <LoginLogo />
      <ResetPasswordForm />
    </Stack>
  );
};
